import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { FilterModalState } from "@tSurya/Store/Data/FilterMenuState";



import { Draft } from "immer";


const initialState: FilterModalState = {
    filterModal: false,
};

const reducer = {
    "Custom/ProductList/SetFilterModal": (draft: Draft<FilterModalState>, action: { result: boolean }) => {
        draft.filterModal = action.result;
    },
};
export default createTypedReducerWithImmer(initialState, reducer);
